// admin-notifications.query-keys.ts

import type { AdminNotificationsFeedFilters } from './admin-notifications.types';

export const adminNotificationQueryKeys = {
  all: ['admin-notifications'] as const,

  feeds: () => [...adminNotificationQueryKeys.all, 'feeds'] as const,

  feed: (filters: AdminNotificationsFeedFilters = {}) =>
    [
      ...adminNotificationQueryKeys.feeds(),
      'page',
      {
        limit: filters.limit ?? 15,
        offset: filters.offset ?? 0,
        cursorCreatedAt: filters.cursorCreatedAt ?? null,
        cursorNotificationId: filters.cursorNotificationId ?? null,
        onlyUnread: filters.onlyUnread ?? false,
      },
    ] as const,

  infiniteFeed: (filters: Omit<AdminNotificationsFeedFilters, 'offset'> = {}) =>
    [
      ...adminNotificationQueryKeys.feeds(),
      'infinite',
      {
        limit: filters.limit ?? 15,
        onlyUnread: filters.onlyUnread ?? false,
      },
    ] as const,

  unreadCount: () =>
    [...adminNotificationQueryKeys.all, 'unread-count'] as const,
};